import {
  any, boolean, nullable, number,
  object, string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PublicVenueMask = {
  active: boolean,
  availableSeating: string,
  averageConnectionTime: number,
  badge: string | nullable,
  billetDescription: string,
  bioLiveMusic: string,
  capacity: any,
  city: string,
  collaborators: any,
  country: string,
  createdAt: any,
  description: string,
  descriptionForPA: string,
  exactCapacity: number | nullable,
  facebookUrl: string,
  featuredReviewId: string | nullable,
  fuzzyLatLng: any,
  hasBillet: boolean,
  hasFinishedShow: boolean,
  hasGreenRoom: boolean,
  hasInstruments: boolean,
  hasMerchSpace: boolean,
  hasPA: boolean,
  hasParking: boolean,
  hasPets: boolean,
  hasPublicTickets: boolean,
  imageFileShareUrl: string,
  instagramUrl: string,
  instrumentDescription: string,
  isAccessible: boolean,
  isPresenter: boolean,
  isVetted: boolean,
  name: string,
  numConnections: number,
  numReviews: number,
  owner: string | nullable,
  parkingDescription: string,
  petsDescription: string,
  postalCode: string,
  primaryGenres: any,
  privateUpdatedAt: any,
  publicImageUrl: any | nullable,
  region: string | nullable,
  score: number,
  socialUrl: string,
  stageDescription: string,
  timezone: string,
  twitterUrl: string,
  updatedAt: any,
  vanityUrl: string,
  vanityUrlCache: any,
  vanityUrlLowercase: string,
  venueClaimsSocan: boolean,
  venueType: string,
  taxRate: number,
  soundcloudUri: string,
  soundcloudUriCache: object,
  spotifyUri: string,
  spotifyUriCache: object,
  youtubeUri: string,
  youtubeUriCache: object,
  vimeoUri: string,
  vimeoUriCache: object,
  bandcampUri: string,
  bandcampUriCache: object,
  websiteUrl: string,
};
